var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-jxbhjf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 572px;\n"], ["\n  width: 572px;\n"])));
var OuterContainer = styled.div.withConfig({ displayName: "OuterContainer", componentId: "sc-iigp1r" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 8px;\n  background: #f0f2f5;\n  padding: 1px;\n  margin-bottom: 6px;\n"], ["\n  border-radius: 8px;\n  background: #f0f2f5;\n  padding: 1px;\n  margin-bottom: 6px;\n"])));
var ProgressInfo = styled.p.withConfig({ displayName: "ProgressInfo", componentId: "sc-15j82k6" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  color: #9096aa;\n  width: fit-content;\n  margin-left: ", ";\n  transform: ", ";\n"], ["\n  margin: 0;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  color: #9096aa;\n  width: fit-content;\n  margin-left: ", ";\n  transform: ", ";\n"])), function (_a) {
    var start = _a.start, end = _a.end;
    return "calc(" + start + " / " + end + " * 100%)";
}, function (_a) {
    var start = _a.start, end = _a.end;
    return start === end ? "translateX(-100%)" : "translateX(-50%)";
});
var ProgressContainer = styled.div.withConfig({ displayName: "ProgressContainer", componentId: "sc-197o7a" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: #42abe9;\n  box-shadow: 4px 2px 6px rgba(66, 171, 233, 0.25);\n  border-radius: 8px;\n  height: 6px;\n  width: ", ";\n"], ["\n  background: #42abe9;\n  box-shadow: 4px 2px 6px rgba(66, 171, 233, 0.25);\n  border-radius: 8px;\n  height: 6px;\n  width: ", ";\n"])), function (_a) {
    var start = _a.start, end = _a.end;
    return "calc(" + start + " / " + end + " * 100%)";
});
var Progress = function (_a) {
    var start = _a.start, end = _a.end, rest = __rest(_a, ["start", "end"]);
    return (_jsxs(Container, __assign({}, rest, { role: 'progressbar' }, { children: [_jsx(OuterContainer, { children: _jsx(ProgressContainer, { start: start, end: end }, void 0) }, void 0), _jsx(ProgressInfo, __assign({ start: start, end: end }, { children: start !== end ? (_jsxs(_Fragment, { children: [start, "/", end, " steps"] }, void 0)) : ('completed') }), void 0)] }), void 0));
};
export { Progress };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
